export default __webpack_public_path__ + "static/media/State Farm Dark.727969b5.svg";